'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showModalRegistration = showModalRegistration;
exports.showModalAuth = showModalAuth;
exports.showModalAuthOneClick = showModalAuthOneClick;
exports.showModalPassRecovery = showModalPassRecovery;
exports.showModalConfirmPhone = showModalConfirmPhone;
exports.showModalConfirmChangePhone = showModalConfirmChangePhone;
exports.showModalConfirmMail = showModalConfirmMail;
exports.showModalChangePassword = showModalChangePassword;
exports.showModalConfirmOldMail = showModalConfirmOldMail;
exports.showAlcoModal = showAlcoModal;
exports.showModifierModal = showModifierModal;
exports.showBuyInCreditModal = showBuyInCreditModal;
exports.showSuccessfulModal = showSuccessfulModal;
exports.showCouponSearchModal = showCouponSearchModal;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modal = require('./modal');

var _components2 = require('components');

var _constants = require('components/Modal/constants');

var _modals = require('components/modals');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function showModalRegistration(lang) {
    var title = 'Registration';
    if (lang) {
        title = lang['store.register.register'];
    }
    return (0, _modal.showModal)({
        title: title,
        content: _react2.default.createElement(_components2.Registration, null),
        modalType: _constants.REGISTRATION
    });
}

function showModalAuth(lang) {
    return (0, _modal.showModal)({
        title: lang['login.logIn'],
        content: _react2.default.createElement(_components2.Auth, null),
        modalType: _constants.AUTH
    });
}

function showModalAuthOneClick() {
    var isCreateOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return (0, _modal.showModal)({
        title: '',
        content: _react2.default.createElement(_components2.AuthOneClick, { isCreateOrder: isCreateOrder }),
        modalType: _constants.AUTH_ONE_CLICK
    });
}

function showModalPassRecovery(lang) {
    return (0, _modal.showModal)({
        title: lang['store.modals.restore_password'],
        content: _react2.default.createElement(_components2.PassRecovery, null),
        modalType: _constants.PASS_RECOVERY
    });
}

function showModalConfirmPhone(pipoId, newPhone, title, succesOperationText) {
    return (0, _modal.showModal)({
        title: title,
        content: _react2.default.createElement(_components2.ConfirmPhone, { pipoId: pipoId, newPhone: newPhone, succesOperationText: succesOperationText }),
        modalType: _constants.CONFIRM_PHONE
    });
}

function showModalConfirmChangePhone(pipoId, newPhone, title, succesOperationText) {
    return (0, _modal.showModal)({
        title: title,
        content: _react2.default.createElement(_components2.ConfirmChangePhone, { pipoId: pipoId, newPhone: newPhone, succesOperationText: succesOperationText }),
        modalType: _constants.CONFIRM_CHANGE_PHONE
    });
}

function showModalConfirmMail(pipoId, newMail, message, lang) {
    return (0, _modal.showModal)({
        title: lang['store.modals.email_confirm'],
        content: _react2.default.createElement(_components2.ConfirmMail, { pipoId: pipoId, newMail: newMail, message: message }),
        modalType: _constants.CONFIRM_MAIL
    });
}

function showModalChangePassword(lang) {
    return (0, _modal.showModal)({
        title: lang['store.modals.password_change'],
        content: _react2.default.createElement(_components2.PasswordChange, null),
        modalType: _constants.PASSWORD_CHANGE
    });
}

function showModalConfirmOldMail() {
    return (0, _modal.showModal)({
        title: lang['store.modals.email_confirm'],
        content: _react2.default.createElement(_components2.ConfirmOldMail, null),
        modalType: _constants.CONFIRM_OLD_MAIL
    });
}

function showAlcoModal(confirmModal, lang) {
    return (0, _modal.showModal)({
        title: lang['store.modals.alcohol'],
        content: _react2.default.createElement(_components2.AlcoModal, null),
        modalType: _constants.ALCOHOL_MODAL,
        onSuccess: confirmModal
    });
}

function showModifierModal(product_detail, title) {
    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    return (0, _modal.showModal)({
        title: title,
        content: _react2.default.createElement(_components2.ModifierModal, { product_detail: product_detail, count: count }),
        modalType: _constants.MODIFIER_MODAL
    });
}

function showBuyInCreditModal(order_detail, title, buy_in_credit) {
    return (0, _modal.showModal)({
        title: title,
        content: _react2.default.createElement(_components2.BuyInCreditModal, { order_detail: order_detail, buy_in_credit: buy_in_credit, title: title }),
        modalType: _constants.BUY_IN_CREDIT_MODAL
    });
}

function showSuccessfulModal(successfulMessage) {
    return (0, _modal.showModal)({
        title: 'Успешно',
        content: _react2.default.createElement(_modals.SuccessfulModal, { successfulMessage: successfulMessage }),
        modalType: _constants.SAVE_SUCCESS
    });
}

function showCouponSearchModal(lang) {
    return (0, _modal.showModal)({
        title: lang['store.iBonus.modals.title'],
        content: _react2.default.createElement(_components2.CouponSearchModal, null),
        modalType: 'couponSearchModal'
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/modal_type.js
// module id = 42
// module chunks = 0